import {
  TrailingInfo,
  TrailingSuccess,
  TrailingDanger
} from '../../atoms/icons/text-input'

const alertVariantComponentOptions = {
  CONFIRMATION: 'confirmation',
  INFORMATION: 'information',
  SUCCESS: 'success',
  DANGER: 'danger'
}

const alertIconVariantOptions = {
  [alertVariantComponentOptions.CONFIRMATION]: <></>,
  [alertVariantComponentOptions.INFORMATION]: <TrailingInfo size='icon-l'/>,
  [alertVariantComponentOptions.SUCCESS]: <TrailingSuccess size='icon-l'/>,
  [alertVariantComponentOptions.DANGER]: <TrailingDanger size='icon-l'/>
}

const alertOrientationVariantOptions = {
  ALIGNED: 'row',
  STACKED: 'column'
}

const alertAlignVariantOptions = {
  START: 'start',
  CENTER: 'center',
  END: 'end'
}

export {
  alertVariantComponentOptions,
  alertIconVariantOptions,
  alertOrientationVariantOptions,
  alertAlignVariantOptions
}
